import { __exports as MSI1010 } from "./index212.js";
import { __require as requireMSI } from "./index175.js";
import { __require as requireChecksums } from "./index210.js";
var hasRequiredMSI1010;
function requireMSI1010() {
  if (hasRequiredMSI1010) return MSI1010;
  hasRequiredMSI1010 = 1;
  Object.defineProperty(MSI1010, "__esModule", {
    value: true
  });
  var _MSI2 = requireMSI();
  var _MSI3 = _interopRequireDefault(_MSI2);
  var _checksums = requireChecksums();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MSI1010$1 = (function(_MSI) {
    _inherits(MSI10102, _MSI);
    function MSI10102(data, options) {
      _classCallCheck(this, MSI10102);
      data += (0, _checksums.mod10)(data);
      data += (0, _checksums.mod10)(data);
      return _possibleConstructorReturn(this, (MSI10102.__proto__ || Object.getPrototypeOf(MSI10102)).call(this, data, options));
    }
    return MSI10102;
  })(_MSI3.default);
  MSI1010.default = MSI1010$1;
  return MSI1010;
}
export {
  requireMSI1010 as __require
};
//# sourceMappingURL=index178.js.map
